import React, { useEffect, useState } from 'react';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { isBrowser } from "react-device-detect";
import Horario from './horario';
import Solicitud from './solicitudEmpleo';
import { get } from 'services';
import WarningNotiifcation from 'components/WarningNotification';
import Form from 'react-bootstrap/Form';

const isBrowserCol12 = isBrowser ? 6 : 12;

const mt15 = {
    marginTop: 15
}

const isBrowserMt = isBrowser ? mt15 : null;

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
})

const ExperienceCard = ({ solicitudEmpleo, puesto, tipoContrato, disponibilidadEntrada }) => {
    const [horarios, setHorarios] = useState([]);
    const [parentescos, setParentescos] = useState([]);

    useEffect(() => {
        (async function mounted() {
            const horariosTipo = await get('HorarioTipo');
            setHorarios(horariosTipo.data)
            const parentescosDB = await get('Parentesco');
            setParentescos(parentescosDB.data)
        })();

        return function cleanup() {
            setHorarios([])
            setParentescos([])
        };
    }, [])


    return (
        <>
            <Card>
                <Card.Body className={'p-30'}>

                    <Row>
                        <Col xs={isBrowser ? 6 : 12}>
                            <Row>
                                {/* <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Puesto </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    {puesto}
                                </Col> */}
                                <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Tipo de contrato </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    {tipoContrato}
                                </Col>
                                <Col style={mt15} xs={isBrowser ? 3 : 12}>
                                    <strong> ¿Trabajas días feriados? </strong>
                                </Col>
                                <Col style={isBrowserMt} xs={isBrowser ? 9 : 12}>
                                    {solicitudEmpleo?.trabajaFeriado ? 'Sí' : 'No'}
                                </Col>
                            </Row>
                        </Col>
                        <Col style={!isBrowser ? mt15 : null} xs={isBrowser ? 6 : 12}>
                            <Row>
                                {/* <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Disponibilidad de entrada </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    {disponibilidadEntrada}
                                </Col> */}
                                <Col xs={isBrowser ? 3 : 12}>
                                    <strong> Aspiración salarial </strong>
                                </Col>
                                <Col xs={isBrowser ? 9 : 12}>
                                    {formatter.format(solicitudEmpleo.salarioAspirado)}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                 
                </Card.Body>
            </Card>
            <br/>
            <Card>
                <Card.Body className={'p-30'}>

                    <Row>
                        <Col xs={isBrowser ? 6 : 12}>
                            <Row>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20 }}>
                                        <strong> Horarios </strong>
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <Row>
                                {
                                    (solicitudEmpleo.solicitudesHorario && solicitudEmpleo.solicitudesHorario.length > 0 && solicitudEmpleo.solicitudesHorario.filter(x => x && x.estado == 1).length > 0) ?
                                        <>
                                            {
                                                solicitudEmpleo.solicitudesHorario.filter(x => x && x.estado == 1).map((horario) => {
                                                    return <Horario key={horario.id} mt15={mt15} isBrowserCol12={isBrowserCol12} horario={horario} horarios={horarios} isBrowserMt={isBrowserMt} />
                                                })
                                            }
                                        </>
                                        : <Form.Group as={Col} md="12">
                                            <br />
                                            <span style={{fontSize: 18}}>  
                                                No ha agregado horarios
                                            </span>
                                            {/* <WarningNotiifcation message='No ha agregado horarios' enphasis='' /> */}
                                        </Form.Group>
                                }
                            </Row>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
            <br/>
            <Card>
                <Card.Body className={'p-30'}>

                    <Row>
                        <Col xs={isBrowser ? 6 : 12}>
                            <Row>
                                <Col xs={12}>
                                    <span style={{ fontSize: 20 }}>
                                        <strong> Empleados conocidos en Humano </strong>
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                            <Row>
                                {
                                    (solicitudEmpleo.solicitudEmpleoEmpleado && solicitudEmpleo.solicitudEmpleoEmpleado.length > 0 && solicitudEmpleo.solicitudEmpleoEmpleado.filter(x => x && x.estado == 1)).length > 0 ?
                                        <>
                                            {
                                                solicitudEmpleo.solicitudEmpleoEmpleado.filter(x => x && x.estado == 1).map((solicitud, index) => {
                                                    return <Solicitud index={index} key={solicitud.id} mt15={mt15} isBrowserCol12={isBrowserCol12} parentescos={parentescos} solicitud={solicitud} isBrowserMt={isBrowserMt} />
                                                })
                                            }
                                        </>
                                        : <Form.Group as={Col} md="12">
                                            <br />
                                            <span style={{fontSize: 18}}>  
                                                No ha agregado empleados
                                            </span>
                                            {/* <WarningNotiifcation message='No ha agregado empleados' enphasis='' /> */}
                                        </Form.Group>
                                }
                            </Row>
                        </Col>
                    </Row>


                </Card.Body>
            </Card>
        </>
    );
};

export default ExperienceCard;